import * as yup from 'yup'

export const ImageMaskSchema = yup.object({
	x: yup.number().min(0).max(100),
	y: yup.number().min(0).max(100),
	width: yup.number().min(0).max(100),
	height: yup.number().min(0).max(100),
	svgId: yup.string(),
	flip: yup.mixed<'x' | 'y' | 'xy' | 'none'>().oneOf(['x', 'y', 'xy', 'none']).default('none').meta({
		description: 'Defines whether the mask is flipped on the v or h axis',
	}),
	rotate: yup.number().min(0).max(360),
	mode: yup.mixed<'alpha' | 'luminance'>().oneOf(['alpha', 'luminance']).default('alpha'),
})
